'use client';

import { GeolocationModal } from 'ui';
import { getConsentPurposes, NO_PURCHASE, OTHER_COUNTRY } from 'onetrust/src';
import { GEOLOCATION_ALLOWED, X_GEO_LOCATION_STATUS } from 'utils';
import { getCookie } from 'cookies-next';
import { trackBrazeUser } from 'braze-react';
import postConsent from '../../../utils/onetrust/postConsent';

export default function GeoModalCaller({ brazeConfig, modalContent, env }) {
  const geoLocationStatus = getCookie(X_GEO_LOCATION_STATUS) || GEOLOCATION_ALLOWED;
  const collectionPoint = geoLocationStatus === GEOLOCATION_ALLOWED ? NO_PURCHASE : OTHER_COUNTRY;
  const consentPurposes = getConsentPurposes(brazeConfig.LINGO_ENV, collectionPoint);

  const createBrazeUser = async (email, signUpSource) => {
    const { externalId } = await fetch(`/api/marketing/user/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        signUpSource,
      }),
    }).then((res) => res.json());

    return externalId;
  };

  return (
    <GeolocationModal
      content={modalContent}
      collectionPoint={collectionPoint}
      consentPurposes={consentPurposes}
      postConsent={postConsent}
      trackBrazeUser={trackBrazeUser}
      createBrazeUser={createBrazeUser}
      env={env}
      styles={{
        title: { variant: 'h2' },
        boldSubtitle: { variant: 'body' },
        subtitle: { variant: 'body' },
        agreement: { variant: 'bodySM' },
      }}
    />
  );
}
